var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-option",class:{
    'select-option--status': _vm.status,
    'select-option--center': _vm.center,
    'select-option--right': _vm.right,
    'select-option--icon': _vm.icon,
    'select-option--flex': _vm.flex,
    'select-option--small': _vm.small
  }},[(_vm.multiple === true)?_vm._l((_vm.options),function(option){return _c('fib-checkbox',{key:option.id,attrs:{"label":option.label,"val":_vm.drillDownPlus ? option.label : option.val,"value":_vm.valueComputed},on:{"clicked":function($event){return _vm.handleCheckboxClicked({
          val: option.val,
          value: option.value,
          label: option.label,
          id: option.id,
          svg: option.svg
        })},"input":function($event){return _vm.handleChangeDirect($event)}}},[(option.svg)?_c('div',{domProps:{"innerHTML":_vm._s(option.svg)}}):_vm._e()])}):_vm._e(),(_vm.multiple === false)?_vm._l((_vm.options),function(ref){
        var val = ref.val;
        var label = ref.label;
        var id = ref.id;
        var svg = ref.svg;
        var icon = ref.icon;
        var leftLabel = ref.leftLabel;
return _c('fib-radio',{key:id,attrs:{"label":label,"left-label":leftLabel,"val":val,"value":_vm.valueComputed,"color":_vm.color},on:{"clicked":function($event){return _vm.handleRadioClicked({ val: val, label: label, id: id, svg: svg })},"input":function($event){return _vm.handleChangeDirect($event)}}},[(svg)?_c('div',{domProps:{"innerHTML":_vm._s(svg)}}):_vm._e(),(icon)?_c('q-icon',{attrs:{"name":icon,"size":_vm.size}}):_vm._e()],1)}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }